ready().then(function() {

    /**
    * For SEO purposes we need to adjust some html
    * https://weekbladpersgroep.atlassian.net/browse/VER-6078
    *
    * We rewrite the html by JS, to avoid double <h1> tags occur in the html - which is bad for SEO purposes,
    * Even when these tags are hidden by CSS in the html
    * 
    * Please note this only occurs on Kinderboeken - so it's custom code
    * 
    * When we refactor - or change the book-info-b.twig file - we do it right, and we can remove this file
    */

    const seoImprovements = () => {

        const fixDoubleH1BookInfoSection = () => {

            const mobilepagetitle = document.querySelector('.hide-md-up h1.page-title');
            const desktoppagetitle = document.querySelector('.hide-sm-down h2.page-title');
            
            if($('section').hasClass('section-book-info-b')) {
                
                if (typeof(mobilepagetitle) != 'undefined' && mobilepagetitle != null && typeof(desktoppagetitle) != 'undefined' && desktoppagetitle != null) {
                    if (mediaBreakPointMaxSm.matches === true ) {
                        desktoppagetitle.outerHTML = "<h2 class='page-title'>" + desktoppagetitle.innerHTML + "</h2>";
                        mobilepagetitle.outerHTML = "<h1 class='page-title'>" + mobilepagetitle.innerHTML + "</h1>";
                    } else {
                        desktoppagetitle.outerHTML = "<h1 class='page-title'>" + desktoppagetitle.innerHTML + "</h1>";
                        mobilepagetitle.outerHTML = "<h2 class='page-title'>" + mobilepagetitle.innerHTML + "</h2>";
                    }
                }
            }
        }
        
        fixDoubleH1BookInfoSection();
    }
    
    seoImprovements();
});